import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, SimpleChanges} from '@angular/core';

import * as _ from 'lodash';

import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/cpg/services/coupons.service';

@Component({
  selector: 'app-create-coupon-select-products',
  templateUrl: './create-coupon-select-products.component.html',
  styleUrls: ['./create-coupon-select-products.component.scss']
})
export class CreateCouponSelectProductsComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER)
  @Output() navigation = new EventEmitter(); // Navigation click event

  public loginData: any;
  public couponData: any;

  public products: any = [];
  public productsPage: number = 1;
  public productsCount: number = 0;
  public searchText: string = '';
  public productsLoading: boolean = false;

  public productsSelected: any = [];

  constructor(
    private _utilService: UtilService,
    private _couponsService: CouponsService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  ngOnChanges(changes: SimpleChanges) {
    /*if (changes.creator.currentValue) {
    }*/
  }

  async getStorageData() {
    if (this.module == 'CPG') {
      this.loginData = await this._utilService.getStorageData('C_LOGIN');
      this.couponData = await this._utilService.getStorageData('C_NEW_COUPON');
    } else if (this.module == 'RETAILER') {
      this.loginData = await this._utilService.getStorageData('R_LOGIN');
      this.couponData = await this._utilService.getStorageData('R_NEW_COUPON');
    }

    // Set products already selected
    this.productsSelected = [];
    if (this.couponData) {
      if( this.couponData.products) {
        this.productsSelected = this.couponData.products;
      }
    }

    this.productsPage = 1;

    this.getProducts();
  }

  // Get products
  getProducts() {
    this.products = [];
    this.productsCount = 0;
    this.productsLoading = true;

    this._couponsService.getProducts(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, this.productsPage, this.searchText.replace("'","''''")).subscribe(async getProductsResponse => {
      this.productsLoading = false;

      if (getProductsResponse.status === true) { // Success
        this.products = getProductsResponse.products;
        this.productsCount = getProductsResponse.total_count;
      } else {
        this._utilService.showToast(getProductsResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getProducts
      this.productsLoading = false;
    });
  }

  // Page change
  onPageChange(event: any) {
    this.productsPage = event;
    this.getProducts();
  }

  // Search product on enter
  onSearchEnter(event: any) {
    if (event.key === 'Enter') {
      this.productsPage = 1;
      this.getProducts();
    }
  }

  // Search product
  searchProduct() {
    this.productsPage = 1;
    this.getProducts();
  }

  // Clear search
  clearSearch() {
    this.searchText = '';
    this.getProducts();
  }

  // Check if product is selected
  isProductSelected(product: any) {
    let tempProductsSelected: any = this.productsSelected;

    tempProductsSelected = _.filter(tempProductsSelected, obj => obj.upc == product.upc);

    if (tempProductsSelected.length == 0) { // Not selected
      return false;
    } else { // Selected
      return true;
    }
  }

  // On product select/remove
  onProductClick(item: any, event: any) {
    let tempProductsSelected: any = this.productsSelected;

    if (event.target.checked) { // Add product
      tempProductsSelected.push({ upc: item.upc, item_name: item.product_name });
      tempProductsSelected = _.uniqBy(tempProductsSelected, 'upc'); // Remove duplicate if any
    } else { // Remove product
      tempProductsSelected = _.filter(tempProductsSelected, obj => obj.upc !== item.upc);
    }

    this.productsSelected = tempProductsSelected; // Add to selected list
  }

  // On navigation click
  async onNavigationClick(action: string) {
    if (this.productsSelected == 0) { // Products not selected
      this._utilService.showToast('Please select products', '', 'warning', {});
    } else { // Add selected products to storage
      if (!this.couponData) { // Empty - First time
        this.couponData = {
          products: this.productsSelected
        }
      } else {
        this.couponData.products = this.productsSelected;
      }

      if (this.module == 'CPG') {
        let responseSetStorageDataC_NEW_COUPON = await this._utilService.setStorageData('C_NEW_COUPON', this.couponData);
      } else if (this.module == 'RETAILER') {
        let responseSetStorageDataC_NEW_COUPON = await this._utilService.setStorageData('R_NEW_COUPON', this.couponData);
      }

      this.navigation.emit({ step: 1, button: action, status : true });
    }
  }

}
